<template>
  <div>
    <search-express-senders @submit="submitSearch" />

    <div class="simiot-table-operation-buttons">
      <a-space>
        <a-button
          type="primary"
          @click="showNewModal"
          v-if="isShowMenu('express_senders/new')"
        >
          新增
        </a-button>
      </a-space>
    </div>

    <a-table
      size="middle"
      :scroll="{ x: 'max-content' }"
      :columns="columns"
      :data-source="data"
      :loading="loading"
      :pagination="false"
      row-key="id"
    >
      <span slot="effective" slot-scope="effective, record">
        <a-space>
          <a-switch
            :checked="effective"
            :loading="editingEffectiveId === record.id"
            @change="(checked) => changeEffective(checked, record)"
          />
        </a-space>
      </span>
      <span slot="is_default" slot-scope="is_default, record">
        <a-space>
          <a-switch
            :checked="is_default"
            :loading="editingIsDefaultId === record.id"
            @change="(checked) => changeIsDefault(checked, record)"
          />
        </a-space>
      </span>
      <span slot="actions" slot-scope="text, record">
        <a-space>
          <a @click="showEditModal(record.id)" v-if="isHasEditPermission">编辑</a>
        </a-space>
      </span>
    </a-table>

    <pagination
      v-show="pagination.total_count > 0"
      :total-count="pagination.total_count"
      :page.sync="query.page"
      :per-page.sync="query.per_page"
      @change="fetchData"
    />
    <new-express-sender
      v-if="isShowNewModal"
      :visible.sync="isShowNewModal"
      @completed="fetchData"
    />
    <edit-express-sender
      v-if="isShowEditModal"
      :visible.sync="isShowEditModal"
      @completed="fetchData"
      :id="editingId"
    />
  </div>
</template>

<script>
import SearchExpressSenders from '@/views/express_senders/Search'
import { hasPermission } from '@/utils/permission'
import {
  findExpressSenders,
  updateExpressSenderEffective,
  updateExpressSenderIsDefault
} from '@/api/express_sender'
import Pagination from '@/components/Pagination'
export default {
  data() {
    return {
      data: [],
      columns: [
        {
          title: '地址',
          dataIndex: 'address',
          width: 280,
          ellipsis: true
        },
        {
          title: '联系人',
          dataIndex: 'contact_name',
          width: 120
        },
        {
          title: '联系电话',
          dataIndex: 'contact_phone',
          width: 140
        },
        {
          title: '是否有效',
          dataIndex: 'effective',
          scopedSlots: { customRender: 'effective' },
          width: 120
        },
        {
          title: '是否默认',
          dataIndex: 'is_default',
          scopedSlots: { customRender: 'is_default' },
          width: 120
        },
        {
          title: '操作',
          dataIndex: 'actions',
          scopedSlots: { customRender: 'actions' },
          width: 100,
          fixed: 'right'
        }
      ],
      isShowNewModal: false,
      isShowEditModal: false,
      editingEffectiveId: 0,
      editingIsDefaultId: 0,
      loading: false,
      editingId: 0,
      pagination: {
        total_count: 0
      },
      query: {}
    }
  },
  components: {
    SearchExpressSenders,
    Pagination,
    NewExpressSender: () => import('@/views/express_senders/New'),
    EditExpressSender: () => import('@/views/express_senders/Edit')
  },
  computed: {
    isHasEditPermission() {
      return hasPermission('express_senders/edit')
    }
  },
  created() {
    this.fetchData()
  },
  methods: {
    isShowMenu(menu) {
      return hasPermission(menu)
    },

    showNewModal() {
      this.isShowNewModal = true
    },

    showEditModal(id) {
      this.editingId = id
      this.isShowEditModal = true
    },

    submitSearch(search) {
      this.query = Object.assign({},
        this.$options.data().query,
        search)
      this.fetchData()
    },

    changeEffective(checked, record) {
      const vm = this
      const effective = checked
      this.$confirm({
        title: effective ? '确定设为有效吗?' : '确定设为无效吗?',
        content: '',
        okText: '确定',
        okType: 'danger',
        cancelText: '取消',
        onOk() {
          vm.editingEffectiveId = record.id
          updateExpressSenderEffective(record.id, { effective: effective })
            .then((res) => {
              vm.editingEffectiveId = 0
              if (res.code === 0) {
                record.effective = checked
              }
            })
            .catch(() => {
              vm.editingEffectiveId = 0
            })
        }
      })
    },

    changeIsDefault(checked, record) {
      const vm = this
      const isDefault = checked
      if (!isDefault) {
        return
      }

      this.$confirm({
        title: '确定设为默认寄件信息吗？其它记录的默认将被取消。',
        content: '',
        okText: '确定',
        okType: 'danger',
        cancelText: '取消',
        onOk() {
          vm.editingIsDefaultId = record.id
          updateExpressSenderIsDefault(record.id, {})
            .then((res) => {
              vm.editingIsDefaultId = 0
              if (res.code === 0) {
                vm.fetchData()
              }
            })
            .catch(() => {
              vm.editingIsDefaultId = 0
            })
        }
      })
    },

    fetchData() {
      this.loading = true
      findExpressSenders(Object.assign({}, this.query)).then((res) => {
        this.data = res.data
        this.pagination = res.pagination
        this.loading = false
      })
    }
  }
}
</script>
